<script>
import TrucksHistorySearch from "@/views/trucks/history/TrucksHistorySearch.vue";
import BaseView from "@/views/BaseView.vue";
import TruckLocationsHistory from "@/views/trucks/history/TruckLocationsHistory.vue";
import LoadingOverlay from "@/components/LoadingOverlay.vue";
import PageHeader from "@/components/PageHeader.vue";

export default {
  name: "TrucksHistory",
  components: { PageHeader, LoadingOverlay, TruckLocationsHistory, TrucksHistorySearch },
  mixins: [BaseView],
  data() {
    return {
      data: null,
      filter: {},
      isLoading: false,
    };
  },
  methods: {
    async refresh() {
      const params = { ...this.filter, ...this.params };
      if (!params.number) return;

      this.isLoading = true;
      try {
        const resp = await this.$api.trucks.getTruckLocations(params.number, params.dateFrom, params.dateTo);
        this.data = resp.data;
      } catch (error) {
        console.error("Error loading locations list: ", error);
      } finally {
        this.isLoading = false;
      }
    },
    async search(params) {
      this.params.page = 1;
      this.filter = params;

      await this.refresh();
    },
  },
};
</script>

<template>
  <v-container :fluid="true" class="pt-6 pb-10 pl-6 pr-6 locations-history">
    <page-header :header="$t('trucks.history')"></page-header>
    <trucks-history-search @search="search" />
    <v-col class="fill-height">
      <truck-locations-history :data="data" />
    </v-col>
    <loading-overlay :loading="isLoading" />
  </v-container>
</template>

<style lang="scss" scoped>
.locations-history {
  height: calc(100vh - 60px);
  position: relative;
}
</style>
